import {
  type NavigateFunction,
  type SetURLSearchParams,
} from "react-router-dom";

export function clearNewSearchParam(setSearchParams: SetURLSearchParams) {
  setSearchParams(
    prev => {
      if (!prev.has("new")) return prev;
      const next = new URLSearchParams(prev);
      next.delete("new");
      return next;
    },
    { replace: true },
  );
}

export function navigateToLogbookEntry(
  navigate: NavigateFunction,
  setSearchParams: SetURLSearchParams,
  logbookId: string,
  idType: string,
  entryId: string,
) {
  const pathname = `/logbook/${logbookId}/${idType}/${entryId}`;

  navigate({ pathname, search: "" }, { replace: true });
  clearNewSearchParam(setSearchParams);
}
